<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-30">
      <el-container>
        <el-aside width="330px">
          <sidebar></sidebar>
        </el-aside>
        <el-main>
          <contTitle :obj="obj" :contTitle="contTitle"></contTitle>
          <div class="mt-30">
            <div class="info_form">
              <!--个人-->
              <el-form
                v-if="userType"
                ref="form"
                :rules="rules"
                :label-position="labelPosition"
                :model="form"
                label-width="100px"
              >
                <el-form-item label="头像 ：" class="head_portrait">
                  <el-upload
                    class="avatar-uploader"
                    :headers="{ token: token }"
                    action="/api/zwb/app/oss/public/upload"
                    accept="image/jpeg,image/png,image/jpg"
                    :on-success="handleAvatarSuccess"
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                  >
                    <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                    <p v-else>
                      <span>选择</span>
                      <span>头像</span>
                    </p>
                  </el-upload>
                </el-form-item>

                <el-form-item label="姓名 : " prop="name" style="width: 85%">
                  <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="所在位置 ：" class="address_box">
                  <el-select
                    v-model="form.province"
                    placeholder="请选择所在省份"
                    style="width: 27%"
                    @change="selectProvimce"
                  >
                    <el-option
                      v-for="(item, index) in provincearr"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="form.city"
                    placeholder="请选择所在城市"
                    style="width: 27%"
                    @change="selectcity"
                  >
                    <el-option
                      v-for="(item, index) in cityarr"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="form.zone"
                    placeholder="请选择所在区域"
                    style="width: 27%"
                  >
                    <el-option
                      v-for="(item, index) in regionarr"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="职位 ：" prop="job" style="width: 85%">
                  <el-input v-model="form.job"></el-input>
                </el-form-item>
                <el-form-item label="所属行业 ：" prop="industry">
                  <el-cascader
                    :options="categoryList"
                    :props="optionProps"
                    v-model="form.industry"
                    :show-all-levels="false"
                    style="width: 82%"
                    @change="onChang()"
                  >
                  </el-cascader>
                </el-form-item>
                <el-form-item label="就职单位 ：" prop="hobby" style="width: 85%">
                  <el-input v-model="form.hobby"></el-input>
                </el-form-item>
                <!-- <el-form-item
                  label="个人邮箱 ："
                  prop="email"
                  style="width: 85%"
                >
                  <el-input v-model="form.email"  @blur="handelBlur"></el-input>
                </el-form-item> -->
                <div class="mt-30">
                  <contTitle :obj="obj" contTitle="账号信息"></contTitle>
                  <el-form-item label="登录手机号 " prop="moble" style="">
                    <!-- <el-input v-model="form.mobile" @focus="modifyloginmobile"></el-input> -->
                    <input v-model="form.mobile" style="100px" /><el-button
                      style="color: red"
                      @click="modifyloginmobile()"
                      >更换登录手机号</el-button
                    >
                  </el-form-item>
                  <el-form-item label="个人邮箱 ：" prop="email" style="width: 85%">
                    <!-- <p class="form_email" @click="bindEamil()">绑定邮箱</p> -->
                    <div v-if="form.email">
                      <input v-model="form.email" style="100px" /><el-button
                        style="color: red"
                        @click="bindEamil()"
                        >更换绑定邮箱&nbsp;&nbsp;&nbsp;&nbsp;</el-button
                      >
                    </div>
                    <div v-else>
                      <el-button style="color: red" @click="bindEamil()"
                        >绑定邮箱</el-button
                      >
                    </div>
                  </el-form-item>
                </div>
                <div style="" class="tel">
                  <p class="text_center">个人简历:</p>
                  <tinymceEditor
                    class="mt-15"
                    v-model="form.detail"
                    ref="editor"
                  ></tinymceEditor>
                </div>
                <div class="mt-30 tel">
                  <button class="success" @click.prevent="onSubmit('form')">
                    提交个人信息
                  </button>
                </div>
              </el-form>
              <!--专家-->
              <el-form
                v-if="expertType"
                ref="expertForm"
                :rules="rulesExpert"
                :label-position="labelPosition"
                :model="expertForm"
                label-width="110px"
              >
                <el-form-item label="头像 ：" class="head_portrait">
                  <el-upload
                    class="avatar-uploader"
                    :headers="{ token: token }"
                    action="/api/zwb/app/oss/public/upload"
                    accept="image/jpeg,image/png,image/jpg"
                    :on-success="handleAvatarSuccess"
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                  >
                    <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                    <p v-else>
                      <span>选择</span>
                      <span>头像</span>
                    </p>
                  </el-upload>
                </el-form-item>

                <el-form-item label="专家姓名 : " prop="name" style="width: 85%">
                  <el-input v-model="expertForm.name"></el-input>
                </el-form-item>
                <el-form-item label="所在位置 ：" class="address_box">
                  <el-select
                    v-model="expertForm.province"
                    placeholder="请选择所在省份"
                    style="width: 27%"
                    @change="selectProvimce"
                  >
                    <el-option
                      v-for="(item, index) in provincearr"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="expertForm.city"
                    placeholder="请选择所在城市"
                    style="width: 27%"
                    @change="selectcity"
                  >
                    <el-option
                      v-for="(item, index) in cityarr"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="expertForm.zone"
                    placeholder="请选择所在区域"
                    style="width: 27%"
                  >
                    <el-option
                      v-for="(item, index) in regionarr"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="专家职业 ：" prop="job" style="width: 85%">
                  <el-input v-model="expertForm.job"></el-input>
                </el-form-item>
                <el-form-item label="所属行业 ：" prop="industry">
                  <el-cascader
                    :options="categoryList"
                    :props="optionProps"
                    v-model="expertForm.industry"
                    :show-all-levels="false"
                    style="width: 82%"
                    @change="onChang()"
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="就职单位 ：" prop="hobby" style="width: 85%">
                  <el-input v-model="expertForm.hobby"></el-input>
                </el-form-item>
                <!-- <el-form-item
                  label="个人邮箱 ："
                  prop="email"
                  style="width: 85%"
                >
                  <el-input v-model="expertForm.email"  @blur="handelBlur"></el-input>
                </el-form-item> -->
                <el-form-item
                  label="提问价格 ："
                  prop="expertQuestionPrice"
                  style="width: 85%"
                >
                  <el-input v-model="expertForm.expertQuestionPrice"></el-input>
                </el-form-item>
                <el-form-item label="专家领域：" prop="expertDes" style="width: 85%">
                  <el-input v-model="expertForm.expertDes"></el-input>
                </el-form-item>
                <!-- <el-form-item label="手机号 ：" prop="mobile" style="width: 85%" >
                  <el-input v-model="expertForm.mobile" @focus="modifyloginmobile"></el-input>
                </el-form-item>
                <el-form-item label="个人邮箱 ：" prop="email" style="width: 85%" >
                  <p class="form_email" @click="bindEamil()">绑定邮箱</p>
                </el-form-item> -->
                <div class="mt-30">
                  <contTitle :obj="obj" contTitle="账号信息"></contTitle>
                  <el-form-item label="登录手机号 " prop="moble" style="">
                    <!-- <el-input v-model="form.mobile" @focus="modifyloginmobile"></el-input> -->
                    <input v-model="expertForm.mobile" style="100px" /><el-button
                      style="color: red"
                      @click="modifyloginmobile()"
                      >更换登录手机号</el-button
                    >
                  </el-form-item>
                  <el-form-item label="邮箱 ：" prop="email" style="width: 85%">
                    <!-- <p class="form_email" @click="bindEamil()">绑定邮箱</p> -->
                    <div v-if="expertForm.email">
                      <input v-model="expertForm.email" style="100px" /><el-button
                        style="color: red"
                        @click="bindEamil()"
                        >更换绑定邮箱&nbsp;&nbsp;&nbsp;&nbsp;</el-button
                      >
                    </div>
                    <div v-else>
                      <el-button style="color: red" @click="bindEamil()"
                        >绑定邮箱</el-button
                      >
                    </div>
                  </el-form-item>
                </div>
                <div class="tel">
                  <p class="text_center">专家履历</p>
                  <tinymceEditor
                    class="mt-15"
                    v-model="expertForm.detail"
                    ref="editor"
                  ></tinymceEditor>
                </div>

                <!--专家账号编辑-->

                <div class="mt-30">
                  <div class="fdc" v-for="(info, index) in qualList" :key="index">
                    <div style="width: 40%">
                      <el-form-item label="资质证书名称 :" style="width: 90%">
                        <el-input v-model="info.name"></el-input>
                      </el-form-item>
                    </div>
                    <div style="width: 60%">
                      <el-form-item class="file" label="专家资质证书 :">
                        <el-input v-model="info.url" style="width: 80%"></el-input>
                        <el-upload
                          class="upload-demo"
                          :headers="{ token: token }"
                          action="/api/zwb/app/oss/public/upload"
                          :before-upload="handlePictureCardPreview"
                          :on-success="
                            (res) => {
                              onSuccess(res, index);
                            }
                          "
                          :show-file-list="false"
                        >
                          <el-button class="file_small" size="small" type="primary"
                            >点击上传</el-button
                          >
                        </el-upload>
                        <el-button
                          v-if="index == 0"
                          class="new_add"
                          @click.prevent="onUplaod()"
                          icon="el-icon-plus"
                          circle
                        ></el-button>
                        <el-button
                          v-else
                          class="new_reduce"
                          icon="el-icon-minus"
                          @click.prevent="removeUplaod(index)"
                          circle
                        ></el-button>
                      </el-form-item>
                    </div>
                  </div>
                </div>

                <div class="mt-30 tel">
                  <button class="success" @click.prevent="expertSubmit('expertForm')">
                    提交个人信息
                  </button>
                </div>
              </el-form>
              <!--企业-->
              <el-form
                v-if="comenyType"
                ref="comanyForm"
                :rules="rulesComany"
                :label-position="labelPosition"
                :model="comanyForm"
                label-width="120px"
              >
                <div class="fsb">
                  <!--左边-->
                  <div style="width: 50%">
                    <el-form-item label="企业名称: " prop="name" style="width: 85%">
                      <el-input v-model="comanyForm.name" clearable   maxlength="30"  @blur="onInputBlur"></el-input>
                    </el-form-item>
                    <el-form-item
                      label="企业类型 ："
                      prop="companyType"
                      style="width: 85%"
                    >
                      <el-select
                        v-model="comanyForm.companyType"
                        placeholder="请选择企业类型"
                        style="width: 100%"
                        clearable
                        @clear="onClear"
                      >
                        <el-option
                          v-for="(item, index) in comenyList"
                          :key="index"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item
                      label="注册资金 ："
                      prop="registeredCapital"
                      style="width: 85%"
                    >
                      <el-input
                        v-model="comanyForm.registeredCapital"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </div>
                  <!--右边-->
                  <div style="width: 50%">
                    <el-form-item label="所属行业 ：" prop="industry">
                      <el-cascader
                        :options="comanyList"
                        :props="optionProps"
                        v-model="comanyForm.industry"
                        :show-all-levels="false"
                        style="width: 77%"
                        @change="onChang()"
                      >
                      </el-cascader>
                    </el-form-item>

                    <el-form-item label="企业联系人 ：" prop="contact" style="width: 85%">
                      <el-input v-model="comanyForm.contact" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="联系方式 ：" prop="telphone" style="width: 85%">
                      <el-input v-model="comanyForm.telphone" clearable></el-input>
                    </el-form-item>
                  </div>
                </div>
                <el-form-item label="经营范围 ：" prop="businessScope" style="width: 92%">
                  <el-input
                    type="textarea"
                    v-model="comanyForm.businessScope"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="企业地址 ：" class="address_box">
                  <el-select
                    v-model="comanyForm.province"
                    placeholder="请选择所在省份"
                    style="width: 30%"
                    clearable
                    @change="selectProvimce"
                  >
                    <el-option
                      v-for="(item, index) in provincearr"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="comanyForm.city"
                    placeholder="请选择所在城市"
                    style="width: 30%"
                    clearable
                    @change="selectcity"
                  >
                    <el-option
                      v-for="(item, index) in cityarr"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="comanyForm.zone"
                    placeholder="请选择所在区域"
                    style="width: 30%"
                    clearable
                  >
                    <el-option
                      v-for="(item, index) in regionarr"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="详细地址 ：" prop="address" style="width: 92%">
                  <el-input v-model="comanyForm.address" clearable></el-input>
                </el-form-item>
                <el-form-item label="SEO关键词 ：" style="width: 92%">
                  <el-input v-model="comanyForm.seokeywords" placeholder="多个关键词之间使用英文逗号分隔" clearable></el-input>
                </el-form-item>
                <el-form-item label="SEO描述 ：" style="width: 92%">
                  <el-input v-model="comanyForm.seodescription" type="textarea" clearable></el-input>
                </el-form-item>

                <div class="mt-30">
                  <contTitle :obj="obj" contTitle="账号信息"></contTitle>
                  <el-form-item label="登录手机号 " prop="mobile" style="">
                    <!-- <el-input v-model="comanyForm.telphone" maxlength="11" clearable@focus="modifyloginmobile"></el-input> -->
                    <input v-model="comanyForm.mobile" style="100px" /><el-button
                      style="color: red"
                      @click="modifyloginmobile()"
                      >更换登录手机号</el-button
                    >
                  </el-form-item>
                  <el-form-item label="邮箱 ：" prop="email" style="width: 85%">
                    <!-- <p class="form_email" @click="bindEamil()">绑定邮箱</p> -->
                    <div v-if="comanyForm.email">
                      <input v-model="comanyForm.email" style="100px" /><el-button
                        style="color: red"
                        @click="bindEamil()"
                        >更换绑定邮箱&nbsp;&nbsp;&nbsp;&nbsp;</el-button
                      >
                    </div>
                    <div v-else>
                      <el-button style="color: red" @click="bindEamil()"
                        >绑定邮箱</el-button
                      >
                    </div>
                  </el-form-item>
                </div>
                <div class="mt-30">
                  <contTitle :obj="obj" :contTitle="contTitle1"></contTitle>
                  <p class="file_text">企业LOGO,上传图片大小格式为149px*147px</p>
                  <el-form-item label="企业LOGO ：" prop="headUrl" class="file mt-20">
                    <el-input
                      v-model="comanyForm.headUrl"
                      style="width: 80%"
                      clearable
                    ></el-input>
                    <el-upload
                      class="upload-demo"
                      :headers="{ token: token }"
                      action="/api/zwb/app/oss/public/upload"
                      :on-success="LogoSuccess"
                      :limit="1"
                      :show-file-list="false"
                      :before-upload="handlePictureCardPreview"
                    >
                      <el-button size="small" type="primary">选择文件</el-button>
                    </el-upload>
                  </el-form-item>
                   <p class="file_text">主页Banner,上传图片的格式为 1920px*399px </p>
                  <el-form-item label="主页Banner ：" prop="banner" class="file mt-20">
                    <el-input
                      v-model="comanyForm.banner"
                      style="width: 80%"
                      clearable
                    ></el-input>
                    <el-upload
                      class="upload-demo"
                      :headers="{ token: token }"
                      action="/api/zwb/app/oss/public/upload"
                      :on-success="onHandelSuccess"
                      :show-file-list="false"
                      :before-upload="handlePictureCardPreview"
                    >
                      <el-button size="small" type="primary">选择文件</el-button>
                    </el-upload>
                  </el-form-item>
                </div>

                <div class="tel mt-30">
                  <p class="text_center">详情介绍</p>
                  <tinymceEditor
                    class="mt-15"
                    v-model="comanyForm.detail"
                    ref="editor"
                  ></tinymceEditor>
                </div>

                <!--企业资质-->
                <!-- :limit="5" 文件数量上传限制 -->
                <div class="tel mt-15">
                  <contTitle :obj="obj" :contTitle="contTitle2"></contTitle>
                  <p class="mt-15">图片信息，最多可以上传5张图片</p>
                  <div class="pictures">
                    <el-upload
                      :headers="{ token: token }"
                      action="/api/zwb/app/oss/public/upload"
                      list-type="picture-card"
                      :on-success="successHandle"
                      :file-list="companyQualificationList"
                      :on-remove="handleRemove"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible" style="height: 200px">
                      <img width="100%" :src="dialogImageUrl" alt="" />
                      <!-- <el-input v-model="companyQualificationListObj.name">-</el-input> -->
                    </el-dialog>
                  </div>
                </div>

                <!--企业宣传片 -->
                <div class="tel mt-15">
                  <contTitle :obj="obj" :contTitle="contTitle3"></contTitle>
                  <div>
                    <p class="file_text">上传视频大小不能超过500MB</p>
                    <el-form-item
                      label="视频文件 ："
                      prop="publicizeVideo"
                      class="file_video"
                    >
                      <el-upload
                        class="avatar-uploader"
                        drag
                        action="uploadUrl"
                        ref="upload"
                        :on-success="handleSuccessVide"
                        :show-file-list="false"
                        :before-upload="handlePreview"
                        :http-request="fnUploadRequest"
                        :on-progress="onProgress"
                        :on-remove="onRemove"
                      >
                      <!--添加进度条-->
                      <el-progress  type="circle"  v-if="showprocess"   :percentage="percentlength"  style="margin-top: 25px"></el-progress>
                      <!--视频添加成功的展示 --> 
                       <video 
                        width="360" 
                        height="180" 
                        controls="controls"
                        :src='comanyForm.publicizeVideo'
                        v-if="comanyForm.publicizeVideo && showprocess === false"> 您的浏览器不支持视频播放</video>
                       <i class="el-icon-upload" v-if="showprocess === false"></i>
                       <div class="el-upload__text" v-if="showprocess === false">将文件拖到此处，或<em>点击上传</em></div>
                      </el-upload>

                      <button class="video_btn" @click.prevent="onRemove()">删除视频</button>
                    </el-form-item>
                    <el-form-item
                      label="视频介绍 ："
                      prop="publicizeVideoDesc"
                      style="width: 85%"
                    >
                      <el-input
                        placeholder="200字以内"
                        maxlength="200"
                        type="textarea"
                        v-model="comanyForm.publicizeVideoDesc"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="mt-30 tel">
                  <button class="success" @click.prevent="comanySubmit('comanyForm')">
                    保存信息
                  </button>
                </div>
              </el-form>

              <!--邮箱绑定-->
              <div class="dialogForm">
                <el-dialog title="绑定邮箱" :visible.sync="dialogFormVisible">
                  <el-form :model="binForm" ref="binForm" :rules="binRules">
                    <el-form-item
                      label="邮箱名称:"
                      :label-width="formLabelWidth"
                      prop="email"
                      style="60%;"
                    >
                      <el-input
                        class="myClass"
                        v-model="binForm.email"
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      prop="imgCode"
                      :label-width="formLabelWidth"
                      label="验证码:"
                      style="60%;"
                    >
                      <el-input
                        class="myClass"
                        placeholder="图形验证码"
                        v-model="binForm.imgCode"
                        maxlength="5"
                      ></el-input>
                      <img
                        class="graphic_code"
                        :src="imgUrl"
                        alt=""
                        @click.prevent="getCaptcha()"
                      />
                    </el-form-item>
                  </el-form>
                  <div slot="footer" class="dialog-footer">
                    <el-button
                      class="footer_but back_color"
                      @click="defineSubmit('binForm')"
                      >确 定</el-button
                    >
                    <el-button class="footer_buts" @click="dialogFormVisible = false"
                      >取 消</el-button
                    >
                  </div>
                </el-dialog>
              </div>

              <!--更换手机号-->
              <div class="mater_dialog">
                <el-dialog title="更换手机号" :visible.sync="dialogMoble">
                  <el-form :model="mobleForm" ref="mobleForm" :rules="mobleRules">
                    <el-form-item
                      label="原手机号:"
                      :label-width="formLabelWidth"
                      prop="oldmobile"
                      style="60%;"
                    >
                      <el-input
                        class="myClass"
                        v-model="mobleForm.oldmobile"
                        autocomplete="off"
                        maxlength="11"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="新手机号:"
                      :label-width="formLabelWidth"
                      prop="newmobile"
                      style="60%;"
                    >
                      <el-input
                        class="myClass"
                        v-model="mobleForm.newmobile"
                        autocomplete="off"
                        maxlength="11"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      prop="imgCode"
                      :label-width="formLabelWidth"
                      label="图形验证码:"
                      style="60%;"
                    >
                      <el-input
                        class="myClass"
                        placeholder="图形验证码"
                        v-model="mobleForm.imgCode"
                        maxlength="5"
                      ></el-input>
                      <img
                        class="graphic_codes"
                        :src="imgUrl"
                        alt=""
                        @click.prevent="getCaptcha()"
                      />
                    </el-form-item>
                    <el-form-item
                      prop="smscode"
                      :label-width="formLabelWidth"
                      label="短信验证码:"
                      style="60%;"
                    >
                      <el-input
                        class="myClass"
                        placeholder="短信验证码"
                        v-model="mobleForm.smscode"
                        maxlength="6"
                      ></el-input>
                      <button class="shortBtn" @click.prevent="onCode()">
                        {{ getCodeText }}
                      </button>
                    </el-form-item>
                  </el-form>
                  <div slot="footer" class="dialog-footer">
                    <el-button
                      class="footer_but back_color"
                      @click="mobleSumit('mobleForm')"
                      >确 定</el-button
                    >
                    <el-button class="footer_buts" @click="dialogMoble = false"
                      >取 消</el-button
                    >
                  </div>
                </el-dialog>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
import { getSelfUserinfo, bindsend, changemodbile, mobleCaptcha } from "@/api/user";
import { personalinfo } from "@/api/my";
import { getUUID } from "@/utils/index";
import { region, getDict ,usernameisexist} from "@/api/coment";
import { expertinfo } from "@/api/expert";
import { companyinfo, systemList,getosstoken } from "@/api/company";
import oss from '../../utils/oss'
import { getToken } from "@/utils/auth";
import sidebar from "../../common/sidebar";
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
import contTitle from "../../common/contTitle";
import tinymceEditor from "../../common/tinymceEditor";
export default {
  inject: ["reload"],
  components: {
    sidebar,
    commBanner,
    titleHead,
    contTitle,
    tinymceEditor
  },
  data() {
    var checkEmail = (rule, value, callback) => {
      // 验证邮箱的正则表达式
      const regEmail = /^\w{1,64}@[a-z0-9\-]{1,256}(\.[a-z]{2,6}){1,2}$/i;
      if (regEmail.test(value)) {
        return callback();
      }
      callback(new Error("请输入合法的邮箱"));
    };
    //验证手机号规则
    var checkMobile = (rule, value, callback) => {
      // 验证手机号的正则表达式
      // const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      const regMobile = /^1[0-9]{10}$/;
      if (regMobile.test(value)) {
        return callback();
      }
      callback(new Error("请输入合法的手机号"));
    };

    var checkMobiles = (rule, value, callback)=>{
       const regMobile = /^((0\d{2,3}))(\d{7,8})$/;
       const regMobiles = /^1[0-9]{10}$/;
       if (regMobile.test(value) || regMobiles.test(value)) {
        return callback();
       }
      callback(new Error("联系电话格式不正确，请输入正确的固定电话或手机号"));
    };
    return {
      contTitle: "个人基本信息",
      contTitle1: "企业形象",
      contTitle2: "企业资质",
      contTitle3: "企业宣传片",
      headTitle: "个人帐户",
      obj: {
        title: "个人帐户",
        isShow: false,
        isColor: true,
        roleType: "",
        personalType: 9,
      },
      imageUrl: "",
      labelPosition: "left",
      form: {
        //个人
        id: "",
        name: "",
        province: "", //省
        city: "", //市
        zone: "", //区
        job: "", //职业
        industry: "", //所属行业
        hobby: "", //个人爱好
        detail: "", //详情介绍
        headUrl: "", //头像
        mobile: "", //手机号
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        province: [{ required: true, message: "请选择省份", trigger: "change" }],
        city: [{ required: true, message: "请选择市/区", trigger: "change" }],
        zone: [{ required: true, message: "请选择区域", trigger: "change" }],
        job: [{ required: true, message: "请输入职位", trigger: "blur" }],
        industry: [{ required: true, message: "请选择所属行业", trigger: "change" }],
        hobby: [{ required: true, message: "请输入就职单位", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            validator: checkMobile,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
      },
      expertForm: {
        //专家
        id: "",
        name: "",
        province: "", //省
        city: "", //市
        zone: "", //区
        job: "", //职业
        industry: "", //所属行业
        hobby: "", //个人爱好
        detail: "", //详情介绍
        headUrl: "", //头像
        mobile: "", //手机号
        expertQuestionPrice: "", //提问价格
        certifications: "", //资质证书
        expertDes: "", //专家描述
      },
      rulesExpert: {
        name: [{ required: true, message: "请输入专家姓名", trigger: "blur" }],
        province: [{ required: true, message: "请选择省份", trigger: "change" }],
        city: [{ required: true, message: "请选择市/区", trigger: "change" }],
        zone: [{ required: true, message: "请选择区域", trigger: "change" }],
        job: [{ required: true, message: "请输入职业", trigger: "blur" }],
        industry: [{ required: true, message: "请选择所属行业", trigger: "change" }],
        // hobby: [{ required: true, message: "请输入就职公司", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            validator: checkMobile,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        expertDes: [{ required: true, message: "请输入专家领域", trigger: "blur" }],
        expertQuestionPrice: [
          { required: true, message: "请输入提问价格", trigger: "blur" },
        ],
      },
      comanyForm: {
        id: "", //企业
        name: "", //企业名称
        province: "", //省
        city: "", //市
        zone: "", //区
        industry: "", //所属行业
        detail: "", //详情介绍
        address: "", //详细地址
        legalPerson: "", //企业法人
        registeredCapital: "", //注册资金
        companyType: "", //企业类型
        contact: "", // 企业联系人
        telphone: "", //企业电话
        businessScope: "", //经营范围
        headUrl: "", //企业LOGO
        banner: "", //主页banner
        companyQualification: "", //企业资质
        publicizeVideo: "", //企业宣传片视频
        publicizeVideoDesc: "", //企业宣传片介绍
        seokeywords:"", // SEO关键词
        seodescription:"", //SEO描述
      },
      rulesComany: {
        name: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        province: [{ required: true, message: "请选择省份", trigger: "change" }],
        city: [{ required: true, message: "请选择市/区", trigger: "change" }],
        zone: [{ required: true, message: "请选择区域", trigger: "change" }],
        industry: [{ required: true, message: "请选择所属行业", trigger: "change" }],
        address: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
        // seokeywords: [{ required: true, message: "请输入SEO关键词", trigger: "blur" }],
        // seodescription: [{ required: true, message: "请输入SEO描述", trigger: "blur" }],
        legalPerson: [{ required: true, message: "请输入企业法人", trigger: "blur" }],
        registeredCapital: [
          { required: true, message: "请输入注册资金", trigger: "blur" },
        ],
        // companyType: [{ required: true, message: "请选择企业类型", trigger: "change" }],
        contact: [{ required: true, message: "请输入企业联系人", trigger: "blur" }],
        telphone: [
          { required: true, message: "请输入企业电话", trigger: "blur" },
          {
            validator: checkMobiles,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        businessScope: [{ required: true, message: "请输入经营范围", trigger: "blur" }],
        headUrl: [{ required: true, message: "请上传企业LOGO", trigger: "change" }],
        banner: [{ required: true, message: "请上传主页Banner", trigger: "change" }],
        // publicizeVideo: [
        //   { required: true, message: "请上传宣传视频", trigger: "change" },
        // ],
        // publicizeVideoDesc: [
        //   { required: true, message: "请输入视频介绍", trigger: "blur" },
        // ],
      },
      dialogFormVisible: false,
      formLabelWidth: "110px",
      binForm: {
        imgCode: "",
        email: "",
      },
      binRules: {
        email: [
          { required: true, message: "请输入个人邮箱", trigger: "blur" },
          {
            validator: checkEmail,
            message: "请输入正确的邮箱地址",
            trigger: "blur",
          },
        ],
        imgCode: [{ required: true, message: "请输入图形验证码", trigger: "blur" }],
      },
      mobleForm: {
        oldmobile: "", //原手机号
        newmobile: "", //新手机号
        imgCode: "", //图形验证码
        smscode: "", //短信验证码
      },
      mobleRules: {
        oldmobile: [
          { required: true, message: "请输入原手机号", trigger: "blur" },
          {
            validator: checkMobile,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        newmobile: [
          { required: true, message: "请输入新手机号", trigger: "blur" },
          {
            validator: checkMobile,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        imgCode: [{ required: true, message: "请输入图形验证码", trigger: "blur" }],
        smscode: [{ required: true, message: "请输入短信验证码", trigger: "blur" }],
      },
      token:getToken(),
      uploadHeaders:'',
      categoryList: [], //行业分类
      comanyList: [], //企业所属行业
      category: [],
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      provincearr: [], //省
      cityarr: [], //市
      regionarr: [], //区
      qualList: [
        {
          name: "",
          url: "",
        },
      ],
      dialogVisible: null,
      dialogImageUrl: null,
      companyQualificationList: [], //证书数组
      userinfo: {},
      userType: false,
      industry_type: "",
      expertType: false,
      comenyType: false,
      comenyList: [], //企业类型
      uid: "",
      imgUrl: "",
      type: "", 
      dialogMoble: false,
      getCodeText: "获取验证码",
      getCodeisWaiting: false,
      disabled:true,

      showprocess: false,//进度条
      percentlength:'',
      uploadUrl:'https://zhiwubang-oss.cn-beijing.aliyuncs.com',
    };
  },
  created() {
    this.getRegion();
    this.getUserinfo();
    this.getCaptcha();
    this.getCailter();
    this.getOss();
    this.type = this.$store.state.user.userInfo.type;
    this.userinfo = this.$store.state.user.userInfo.data;
    this.mobleForm.oldmobile = this.userinfo.mobile;
    switch (this.type) {
      case 1:
        this.userType = true;
        this.obj.roleType = this.type;
        break;
      case 2:
        this.expertType = true;
        this.obj.roleType = this.type;
        this.headTitle = "专家账户";
        this.obj.title = "专家账户";
        break;
      case 3:
        this.comenyType = true;
        this.obj.roleType = this.type;
        this.contTitle = "企业基本信息";
        this.headTitle = "企业账户";
        this.obj.title = "企业账户";
        break;
      default:
        break;
    }
  },
  computed: {
    userinfoType() {
      return this.$store.state.user.userInfo && this.$store.state.user.userInfo.type;
    },
    comanyIndustry(){
      return this.$store.getters.comanyIndustry;
    }
  },
  watch: {
    comanyIndustry:{
      handler(val){
        this.comanyList = val ;
      },
      immediate:true
    }
  },
  methods: {
	//获取上传授权
    getOss(){
      getosstoken().then((res)=>{
        if(res.code == 0){
          this.uploadHeaders = res.data.securityToken;
          sessionStorage.setItem('dataOss',JSON.stringify(res.data))
        }
      }).catch((err)=>{})
    },
    //检查用户是否存在
    onInputBlur(){
      if (this.comanyForm.name != "") {
        let params = {
          name: this.comanyForm.name,
        };
        usernameisexist(params).then((res)=>{
          if(res.code == 0){}
        }).catch((err)=>{})
      } else {
        return false;
      }
    },
    //获取图形验证码
    getCaptcha() {
      this.uid = getUUID();
      this.imgUrl = `/api/zwb/app/captcha.jpg?uuid=${this.uid}`;
    },
    //上传成功
    handleAvatarSuccess(res) {
      if (res.code == 0) {
        this.$message({
          message: "上传成功！",
          type: "success",
        });
        this.imageUrl = res.url;
        this.form.headUrl = res.url;
        this.expertForm.headUrl = res.url;
      }
    },
    //上传前回调
    beforeAvatarUpload(file) {
      //上传前对图片类型和大小进行判断
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG,PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    //行业类别
    getCailter() {
      let params = { code: this.industry_type };
      getDict(params)
        .then((res) => {
          if (res.code == 0) {
            this.comenyList = res.data[6].children;
            this.comanyForm.companyType = this.comenyList[0].id;
            this.categoryList = res.data[0].children;
          }
        })
        .catch((err) => {});
    },
    //获取省市区
    async getRegion(row) {
      let params = {
        regionId: "",
      };
      await region(params)
        .then((res) => {
          if (res.code == 0) {
            this.provincearr = res.data;
          }
        })
        .catch((err) => {});
    },
    //获取市
    selectProvimce(row) {
      let params = { regionId: row };
      region(params)
        .then((res) => {
          if (res.code == 0) {
            this.cityarr = res.data;
            // this.form.city = this.cityarr[0].id;
          }
        })
        .catch((err) => {});
    },
    //获取区
    selectcity(row) {
      let params = { regionId: row };
      region(params)
        .then((res) => {
          if (res.code == 0) {
            this.regionarr = res.data;
            // this.form.zone = this.regionarr[0].id;
          }
        })
        .catch((err) => {});
    },
    getUserinfo() {
      getSelfUserinfo().then((res) => {
        const { data } = res;
        if (data) {
          this.selectProvimce(data.province);
          this.selectcity(data.city);
          this.selectcity(data.zone);
          switch (this.type) {
            case 1:
              this.form = data;
              this.imageUrl = this.form.headUrl;
              break;
            case 2:
              this.expertForm = data;
              this.qualList = JSON.parse(data.certifications);
              this.imageUrl = this.expertForm.headUrl;
              this.expertForm.telphone = data.mobile;
              break;
            case 3:
              this.comanyForm = data;
              if(this.comanyForm.companyType == 0){
                this.comanyForm.companyType =  null;
              }
              if (
                null !== data.companyQualification &&
                "null" !== data.companyQualification &&
                data.companyQualification.length > 0
              ) {
				this.companyQualificationList = JSON.parse(data.companyQualification);
              }
              break;
            default:
              break;
          }
        }
      });
    },
    handleChange() {},
    //提交个人信息
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.id = this.$store.state.user.userInfo.data.id;
          personalinfo(this.form)
            .then((res) => {
              if (res.code == 0) {
                console.log("输出测试")
                console.log(res)
                this.$message({
                  message: "编辑成功！"+res.inviteCode,
                  type: "success",
                  duration: 1000,
                  onClose: () => {
                    this.$store.dispatch("user/getInfo");
                    this.$store.state.user.userInfo = null;
                    this.$router.replace("/number");
                  },
                });
                // this.getUserinfo()
              }
            })
            .catch((err) => {});
        } else {
         this.$message({
			message: "请填写完整信息",
			type: "info",
			duration: 3000,
         })
        }
      });
    },
    //专家
    expertSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.expertForm.id = this.$store.state.user.userInfo.id;
          this.expertForm.certifications = JSON.stringify(this.qualList).toString();
		  if(this.expertForm.detail != null){
			  this.expertForm.detail = this.expertForm.detail.replace(/\,/g,"，");
		  }
          expertinfo(this.expertForm)
            .then((res) => {
              if (res.code == 0) {
                this.$message({
                  message: "编辑成功！",
                  type: "success",
                  duration: 1000,
                  onClose: () => {
                    this.$store.dispatch("user/getInfo");
                    this.$store.state.user.userInfo = null;
                    this.$router.push("/number");
                  },
                });
                // this.getUserinfo()
              }
            })
            .catch((err) => {});
        } else {
          this.$message({
			message: "请填写完整信息",
			type: "info",
			duration: 3000,
          })
        }
      });
    },
    //专家上传资质证书
    onUplaod() {
      if (this.qualList.length >= 5) {
        return false;
      } else {
        this.qualList.push({ name: "", url: "" });
      }
    },
    //删除
    removeUplaod(index) {
      this.qualList.splice(index, 1);
    },
    // 资质照片
    onSuccess(res, index) {
      if (res.code == 0) {
        this.$message({
          message: "上传成功!",
          type: "success",
        });
        if (index == 0 || index) {
          this.qualList[index].url = res.url;
        }
      }
    },
    //企业logo上传
    LogoSuccess(file){
      if(file.code == 0){
        this.$message({
          message: "上传成功!",
          type: "success",
        });
       this.$set(this.comanyForm,"headUrl",file.url);
      }       
    }, 
    //图片放大
    handleCardPreview(file) {
      return false;
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //上传文件格式校验
    handlePictureCardPreview(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
		file.type === "image/gif";
      const isLtM = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG,PNG,JPEG,GIF 格式!");
      }

      if (!isLtM) {
        this.$message.error("上传文件大小不能超过 2MB!");
      }

         // }else{
      //    const isSize = new Promise((resolve, reject) => {
      //           const width = 1920;
      //           const height = 399;
      //           const _URL = window.URL || window.webkitURL;
      //           const img = new Image();
      //           img.onload = () => {
      //               const valid = img.width >= width && img.height >= height && img.width === img.height;
      //               valid ? resolve() : reject();
      //           };
      //           img.src = _URL.createObjectURL(file);
      //       }).then(
      //           () => {
      //               return file;
      //           },
      //           () => {
      //               this.$message.error('图片尺寸限制最小为1920 x 399，大小不可超过1MB');
      //               return Promise.reject();
      //           },
      //       );
      //       return isSize;

      // }
      return isLtM;
    },
    //企业
    comanySubmit(formName) {
      this.comanyForm.id = this.$store.state.user.userInfo.data.id;
      this.$refs[formName].validate((valid) => {
        if (valid) {
		   if(this.comanyForm.detail != null){
			   this.comanyForm.detail =  this.comanyForm.detail.replace(/\,/g,"，"); 
		   }		  
           if(this.comanyForm.companyType == null){
             this.comanyForm.companyType = 0 ;
           }
          companyinfo(this.comanyForm)
            .then((res) => {
              if (res.code == 0) {
                this.$message({
                  message: "编辑成功！",
                  type: "success",
                  duration: 1000,
                  onClose: () => {
                    this.$store.dispatch("user/getInfo");
                    this.$store.state.user.userInfo = null;
                    this.$router.push("/corporate_news");
                    //window.location.reload();
                  },
                });
              }
            })
            .catch((err) => {});
        } else {
		  this.$message({
			message: "请填写完整信息",
			type: "info",
			duration: 3000,
		  })
        }
      });
    },
    //上传banner
    onHandelSuccess(data) {
      if (data.code == 0) {
        this.$message({
          message: "上传成功！",
          type: "success",
        });
        this.comanyForm.banner = data.url;
      }
    },
    //上传视频,成功后回调
    handleSuccessVide(response) {
      if(response != undefined){
       if(response.res.statusCode == 200 ){
          this.$message({
            message: "上传成功！",
            type: "success",
          }); 
         //将图片路径保存
         let url = response.res.requestUrls[0];
         let urls = url.split("?")[0];
         this.showprocess = false;
         this.$set(this.comanyForm, "publicizeVideo", urls);
       }else{
         this.$message.error('视频上传失败，请重新上传！')
      }
     }
    },

    async fnUploadRequest(option){
        await oss.ossUploadFile(option);
    },
     //上传视频文件格式验证
    handlePreview(file) {
      if (
        [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb",
        ].indexOf(file.type) == -1
      ) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
      const isLt500M = file.size / 1024 / 1024 < 500;
      if (!isLt500M) {
        this.$message.error("上传视频大小不能超过500MB哦!");
        return false;
      }
    },
    onProgress(option){
     this.showprocess = true;
     this.percentlength = option.percent;
    },
    //企业资质证书
    successHandle(response) {
      if (response.code == 0) {
        this.dialogImageUrl = response.url;
		var obj = {
			name: new Date().getTime().toString(),
			url: response.url
	    };
		this.companyQualificationList.push(obj)
        this.comanyForm.companyQualification = JSON.stringify(this.companyQualificationList);
        this.$message({
          message: "上传成功！",
          type: "success",
        });
      }
    },
    //删除资质证书
    handleRemove(file, fileList) {
      this.comanyForm.companyQualification = JSON.stringify(fileList);
    },
    modifyloginmobile() {
      this.dialogMoble = true;
    },
    mobleSumit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getChangemodbile();
        } else {
          return false;
        }
      });
    },
    //跟换手机号
    getChangemodbile() {
      let params = {
        oldmobile: this.mobleForm.oldmobile,
        newmobile: this.mobleForm.newmobile,
        smscode: this.mobleForm.smscode,
      };
      changemodbile(params)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "更换成功！",
              type: "success",
              duration: 1000,
            });
            this.$store.dispatch("user/logout");
            localStorage.clear();
            this.$router.push("/login");
          }
        })
        .catch((err) => {});
    },
    //倒计时
    setTimer() {
      let holdTime = 60;
      this.getCodeText = "重新获取(60)";
      this.Timer = setInterval(() => {
        if (holdTime <= 0) {
          this.getCodeisWaiting = false;
          this.getCodeText = "获取验证码";
          holdTime = 60;
          clearInterval(this.Timer);
          return;
        }
        this.getCodeText = "重新获取(" + holdTime + ")";
        holdTime--;
      }, 1000);
    },
    //发送验证码
    onCode() {
      if (!this.mobleForm.newmobile) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      if (!this.mobleForm.imgCode) {
        this.$message({
          message: "请输入图形验证码",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      if (this.getCodeisWaiting) {
        return false;
      }
      let params = {
        uuid: this.uid,
        newmob: this.mobleForm.newmobile,
        imgCode: this.mobleForm.imgCode,
      };
      this.setTimer();
      this.getCodeisWaiting = true;
      mobleCaptcha(params)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "验证码发送成功",
              type: "success",
              duration: 1000,
            });
          }
        })
        .catch((err) => {});
    },
    //邮箱绑定
    bindEamil() {
      this.dialogFormVisible = true;
    },
    //邮箱绑定
    defineSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let postData = {
            imgcode: this.binForm.imgCode,
            sendto: this.binForm.email,
            uuid: this.uid,
          };
          bindsend(postData)
            .then((res) => {
              if (res.code == 0) {
                this.$message({
                  message: "绑定成功！",
                  type: "success",
                  duration: 1000,
                });
                this.$store.dispatch("user/getInfo");
				this.getUserinfo();
                this.dialogFormVisible = false;
              }
            })
            .catch((err) => {});
        } else {
          return false;
        }
      });
    },
    handelBlur() {
      if (!this.form.email || !this.expertForm.email || !this.comanyForm.email) {
        return false;
      } else {
        let postData = {
          imgcode: "",
          sendto: "",
          uuid: this.uid,
        };
        switch (this.type) {
          case 1:
            postData.imgcode = this.form.imgCode;
            postData.sendto = this.form.email;
            break;
          case 2:
            postData.imgcode = this.expertForm.imgCode;
            postData.sendto = this.expertForm.email;
            break;
          case 3:
            postData.imgcode = this.comanyForm.imgCode;
            postData.sendto = this.comanyForm.email;
            break;
          default:
            break;
        }
        bindsend(postData)
          .then((res) => {
            if (res.code == 500) {
              this.form.email = "";
              this.expertForm.email = "";
              this.comanyForm.email = "";
            }
          })
          .catch((err) => {});
      }
    },
    //选中
    onChang() {
      switch (this.type) {
        case 1:
          this.form.industry = this.form.industry[this.form.industry.length - 1];
          break;
        case 2:
          this.expertForm.industry = this.expertForm.industry[
            this.expertForm.industry.length - 1
          ];
          break;
        case 3:
          this.comanyForm.industry = this.comanyForm.industry[
            this.comanyForm.industry.length - 1
          ];
          break;
      }
    },
    onClear(){
      this.comanyForm.companyType =  null;
    },
    //删除视频
    onRemove(file){   
      this.comanyForm.publicizeVideo = '';
      this.showprocess = false;
      this.$refs.upload.abort(); //取消上传
    }
  },
};
</script>

<style scoped="scoped">
.el-aside {
  height: 100%;
}
.el-main{
  overflow:hidden;
}
.fsb {
  display: flex;
  justify-content: flex-start;
}
.tel {
  text-align: left;
}
.mt-15 {
  margin-top: 15px;
}
.mt-20 {
  margin-top: 20px;
}
.form_email {
  width: 78px;
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  color: #666666;
  border-radius: 3px;
  text-align: center;
  cursor: pointer;
  border: 1px solid #ebebeb;
}
.myClass {
  width: 80%;
}
.back_color {
  background-color: #3bbb35;
  color: #ffffff;
}
.dialogForm >>> .el-dialog {
  width: 500px;
}
.dialogForm >>> .dialog-footer {
  text-align: center;
  margin-left: 30px;
}
.dialogForm >>> .footer_but {
  height: 39px;
  width: 108px;
}
.dialogForm >>> .footer_buts {
  width: 108px;
  height: 39px;
}
.dialogForm >>> .footer_buts:hover {
  background: #fff;
  color: #000;
  border-color: #ebebeb;
}

.head_portrait >>> .avatar-uploader .el-upload {
  border: 1px solid #d2d2d2;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border-radius: 50%;
  background: #ededed;
}
.head_portrait >>> .avatar-uploader .el-upload:hover {
  border-color: #d2d2d2;
}
.head_portrait >>> .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 90px;
  height: 90px;
  line-height: 90px;
  text-align: center;
}
.head_portrait >>> .avatar {
  width: 90px;
  height: 90px;
  display: block;
}
.head_portrait p {
  display: flex;
  flex-direction: column;
  width: 90px;
  height: 90px;
}
.head_portrait p span {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.head_portrait p span:nth-child(1) {
  margin-top: 15px;
}
.head_portrait p span:nth-child(2) {
  margin-top: -20px;
}

.el-form-item {
  text-align: left;
}
.info_form >>> .el-input__inner {
  height: 50px;
}

.info_form >>> .el-button--primary {
  background: #e5e5e5;
  border-color: #e5e5e5;
  height: 50px;
  width: 100px;
  color: #9a9a9a;
}
.info_form >>> .upload-demos {
  position: absolute;
  top: 0;
  right: 0;
}
.upload_btn {
  width: 155px !important;
  height: 40px;
  background: #e5e5e5 !important;
  border: 1px solid #999999;
  font-size: 12px !important;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333 !important;
}
.new {
  display: flex;
  justify-content: left;
  align-items: center;
}
.new_add {
  margin-top: -20px;
  margin-left: 15px;
}
.new_reduce {
  margin-top: -20px;
  margin-left: 15px;
}

.success {
  width: 129px;
  height: 35px;
  background: #3bbb35;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
}
.text_center {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.file {
  position: relative;
}
.upload-demo {
  position: absolute;
  top: 0;
  right: 20%;
}
.file_video {
  position: relative;
  margin-bottom: 20px;
  height: 240px;
  margin-top: 10px;
}
.file_text{
  margin-top: 15px;
  font-size: 14px;
  color: #999999;
  text-align: left;
}
.video_btn{
  width: 100px;
  height: 35px;
  border-radius: 3px;
  background: #3bbb35;
  color: #ffffff;
}
.file_video >>>video{
  object-fit: cover;
}
.el-progress {
  margin-top: 26px;
}
.progress.el-progress {
  display: inline-block;
}
.el-upload__tip {
  margin-top: -14px;
}
.avatar {
  width: 100%;
  height: 177px;
}

.file_small {
  height: 50px;
  width: 125px;
  background: #e5e5e5;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9a9a9a;
  line-height: 0;
  border: none;
}

.graphic_code {
  position: absolute;
  right: 69px;
  top: 0;
  width: 125px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  background: #cdcdcd;
  color: #323232;
}
.graphic_codes {
  position: absolute;
  right: 121px;
  top: 0;
  width: 125px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  background: #cdcdcd;
  color: #323232;
}
.pictures {
  margin-top: 20px;
}
.shortBtn {
  position: absolute;
  top: 0;
  right: 121px;
  width: 125px;
  height: 50px;
  background: #e5e5e5;
}
.mater_dialog >>> .dialog-footer {
  text-align: center;
  margin-left: 30px;
}
.mater_dialog >>> .footer_but {
  height: 39px;
  width: 108px;
}
.mater_dialog >>> .footer_buts {
  width: 108px;
  height: 39px;
}
.mater_dialog >>> .footer_buts:hover {
  background: #fff;
  color: #000;
  border-color: #ebebeb;
}
.dialogForm >>>.el-button--default:hover{
    background: #3bbb35;
	color: #FFFFFF;
}
.mater_dialog >>>.el-button--default:hover{
	background: #3bbb35;
	color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/view/coment/personal_information.vue